export interface userPoolData {
  UserPoolId: string;
  ClientId: string;
  ClientSecret: string;
}
export enum CognitoUserStatus {
  CONFIRMED = 'CONFIRMED',
  UNCONFIRMED = 'UNCONFIRMED',
  ARCHIVED = 'ARCHIVED',
  COMPROMISED = 'COMPROMISED',
  UNKNOWN = 'UNKNOWN',
  RESET_REQUIRED = 'RESET_REQUIRED',
  FORCE_CHANGE_PASSWORD = 'FORCE_CHANGE_PASSWORD',
  DISABLED = 'DISABLED',
}
export enum UserActivationStatus {
  ACTIVATED = 'ACTIVATED',
  INACTIVE = 'INACTIVE',
  DEACTIVATED = 'DEACTIVATED',
}
export enum CognitoAuthFlow {
  USER_PASSWORD_AUTH = 'USER_PASSWORD_AUTH',
  CUSTOM_AUTH = 'CUSTOM_AUTH',
  REFRESH_TOKEN_AUTH = 'REFRESH_TOKEN_AUTH',
}

export enum CognitoAuthChallenge {
  CUSTOM_CHALLENGE = 'CUSTOM_CHALLENGE',
}

export enum UserCognitoAttributes {
  ENABLE_EMAIL_2FA = 'custom:email_mfa_enabled',
  OTP_REQUIRED = 'custom:otp_required',
}
